import { borderRadius } from '@eversports/design-tokens/border-radius'
import { boxShadows } from '@eversports/design-tokens/box-shadows'
import { MenuProps, default as MuiMenu } from '@mui/material/Menu'
import * as React from 'react'

/**
 * @deprecated Use the Popover component instead
 */
const Menu: React.FC<React.PropsWithChildren<MenuProps>> = ({ sx, ...props }) => {
  return (
    <MuiMenu
      sx={{
        '& .MuiMenu-paper': {
          border: '1px solid #F2F2F2',
          boxShadow: boxShadows.hover,
          borderRadius: `${borderRadius.default}px`,
          py: 2,
          px: 4,
        },
        '& .MuiMenu-list': {
          padding: 0,
        },
        ...sx,
      }}
      {...props}
    />
  )
}

export default Menu
